import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { SurveyQuestion_FreeText, SurveyQuestion_Scale } from '@app/advisor-shared';
import { reduceToMap } from '@nu-art/ts-common';
import { FadeScrollWrapper } from '@app/styles';
import { Renderer_SurveyComponentFreeText, Renderer_SurveyComponentScale } from '../survey-components/index.js';
import './Renderer_Survey.scss';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
export class Renderer_Survey extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.survey ??= nextProps.survey;
        // initiate empty mapper of all questions answers
        state.payload ??= { answers: reduceToMap(state.survey.components, item => item._id, item => undefined) };
        return state;
    }
    rendererIndex = (component) => {
        switch (component.inputType) {
            case SurveyQuestion_Scale:
                return _jsx(Renderer_SurveyComponentScale, { onChange: value => this.handleChange(component, value), currentValue: this.state.payload.answers[component._id], question: component });
            case SurveyQuestion_FreeText:
                return _jsx(Renderer_SurveyComponentFreeText, { onChange: value => this.handleChange(component, value), currentValue: this.state.payload.answers[component._id], question: component });
            default:
                this.logWarning(`cannot find any renderer for type ${component.inputType}`);
                return _jsx(_Fragment, {});
        }
    };
    handleChange(component, value) {
        const currentAnswers = this.state.payload.answers;
        return this.setState({
            payload: {
                ...this.state.payload,
                answers: {
                    ...currentAnswers,
                    [component._id]: currentAnswers?.[component._id] === value ? undefined : value
                }
            }
        }, () => ModuleFE_ScrollBar.updateScrollBar(this.props.scrollRef));
    }
    renderControls = () => {
        return _jsx(LL_H_C, { className: 'survey__controls', children: _jsx(Button, { onClick: () => this.props.submitAction(this.state.payload), variant: 'primary', children: "Submit" }) });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'survey-renderer', children: [_jsx(FadeScrollWrapper, { scrollRef: this.props.scrollRef, children: this.state.survey.components.map(component => _jsx(React.Fragment, { children: this.rendererIndex(component) }, component._id)) }), this.renderControls()] });
    }
}
//# sourceMappingURL=Renderer_Survey.js.map